<template>
  <b-modal
    :visible="visible"
    :title="`${$t('members')}: ${roleName}`"
    @change="$emit('update:visible', $event)"
    @shown="selectedUsers = initialUsers"
  >
    <multiselect
      v-model="selectedUsers"
      :options="users"
      :multiple="true"
      :close-on-select="false"
      :custom-label="userLabel"
      track-by="id"
      :placeholder="$t('addMember')"
      :show-labels="false"
    />

    <template #modal-footer>
      <b-button variant="bg" @click="submit">{{ $t('save') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'RoleMembersDialog',
  components: { Multiselect },
  props: {
    visible: { type: Boolean, default: false },
    roleName: { type: String, default: '' },
    users: { type: Array, required: true },
    memberIds: { type: Array, default: () => [] },
  },
  data() {
    return { selectedUsers: [] };
  },
  computed: {
    initialUsers() {
      return this.users.filter((user) => this.memberIds.includes(user.id));
    },
  },
  methods: {
    userLabel(user) {
      return `${user.firstname} ${user.lastname}`;
    },
    submit() {
      this.$emit(
        'submit',
        this.selectedUsers.map((user) => user.id)
      );
      this.$emit('update:visible', false);
    },
  },
};
</script>
